import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Navigate, useSearchParams } from 'react-router-dom';
import actions from '../../redux/user/actions';
import { routePaths } from '../routes';

const { setUserCurrentWorkspace } = actions;

export function Authentication() {
  const dispatch = useDispatch();
  const [isAuthenticated] = useState(localStorage.getItem('tokens'));
  const [searchParams] = useSearchParams();

  const workspaceAction = searchParams.get('workspace');
  const organizationId = searchParams.get('organization');
  const propertyId = searchParams.get('farm');

  if (!isAuthenticated) {
    window.location.href = `${
      import.meta.env.VITE_APP_CROPWISE_AUTH
    }/oauth/authorize?response_type=code&client_id=${
      import.meta.env.VITE_APP_CLIENT_ID
    }&redirect_uri=${window.location.origin}/${import.meta.env.VITE_APP_REDIRECT_URI}`;

    return null;
  }
  if (workspaceAction) {
    dispatch(setUserCurrentWorkspace(workspaceAction));
  }

  if (organizationId) {
    if (propertyId) {
      return (
        <Navigate to={`${routePaths.organizations}/${organizationId}/properties/${propertyId}`} />
      );
    }

    return (
      <Navigate
        to={`${routePaths.organizations}/workspace/${workspaceAction}/organization/${organizationId}`}
      />
    );
  }

  return <Navigate to={routePaths.organizations} />;
}

export default Authentication;
